// src/ScrollToTop.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
var ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// src/ScrollToTopButton.tsx
import {
  Box,
  useScrollTrigger,
  useTheme,
  Zoom
} from "@mui/material";
import { jsx } from "react/jsx-runtime";
var ScrollToTopButton = ({
  children,
  anchorId,
  ...props
}) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100
  });
  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(`#${anchorId}`);
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  const theme = useTheme();
  return /* @__PURE__ */ jsx(Zoom, { in: trigger, ...props, children: /* @__PURE__ */ jsx(Box, { zIndex: 10, position: "fixed", right: theme.spacing(2), bottom: theme.spacing(2), onClick: handleClick, role: "presentation", children }) });
};
export {
  ScrollToTop,
  ScrollToTopButton
};
//# sourceMappingURL=index.mjs.map